import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { errorToast, successToast } from "../../../../react-toastfiy/toast";
import taService from "../services/ta.service";

export default function useCreateTAUserModal(onHide) {
  const history = useHistory();
  const [taUserData, setTAUserData] = useState("");
  const [TAUserList, setTAUserList] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const value = ["AB"];
        const formData = new FormData();
        formData.append("shorthandsList", JSON.stringify(value));
        const response = await taService.GetUserList(formData);
        if (response?.status === 200) {
          const TA_user_list = response?.data.map((val) => ({
            label: `${val?.phone}  (${val?.userName} ${
              val?.is_user_channel_financed ? "-  TA User" : ""
            })`,
            value: val,
          }));
          setTAUserList(TA_user_list);
        }
      } catch (error) {
        errorToast(error?.msg || "Something went wrong");
      }
    };

    fetchData();
  }, []);
  const handleSelect = (e) => {
    setTAUserData(e.value);
  };
  const handleSelectedUserConformation = async (e) => {
    if (!taUserData?.is_user_channel_financed) {
      // Check if TA financier is not applicable for this state
      if (!taUserData?.is_ta_financier_applicable) {
        try {
          setButtonLoader(true);
          const formData = new FormData();
          formData.append("phone", taUserData?.phone);
          
          const response = await taService.RequestAdminApproval(formData);
          
          if (response?.status === 200) {
            setButtonLoader(false);
            // Close the modal first
            if (onHide) {
              onHide();
            }
            // Show success alert
            await Swal.fire({
              title: "Success!",
              text: response?.msg || "Request sent to admin for approval successfully. Onboarding will begin after admin approval.",
              icon: "success",
              confirmButtonText: "OK",
              allowOutsideClick: true,
            });
            // Reload page after alert is dismissed
            window.location.reload();
          } else {
            errorToast(response?.msg || "Failed to send request for approval");
            setButtonLoader(false);
          }
        } catch (error) {
          setButtonLoader(false);
          errorToast(error?.msg || "Something went wrong");
        }
      } else {
        // Normal flow - proceed to create TA user
        history.push({
          pathname:
            "/auction_representative/user_home/manage-ta-onboard/create-ta-user",
          state: { data: taUserData },
        });
        setButtonLoader(false);
      }
    } else {
      errorToast(
        "This is TA User please select another user to create TA user"
      );
    }
  };

  return {
    buttonLoader,
    taUserData,
    TAUserList,
    handleSelectedUserConformation,
    handleSelect,
  };
}
